// @flow

export const ADD_CHILDREN_TO_DASHBOARD = 'ADD_CHILDREN_TO_DASHBOARD';
export const BRIDGE_NODE_CREATED = 'BRIDGE_NODE_CREATED';
export const BRIDGE_STATUS_UPDATE = 'BRIDGE_STATUS_UPDATE';
export const PAIR_WITH_BRIDGE = 'PAIR_WITH_BRIDGE';
export const POLL_HUE_BRIDGE_STATUS = 'POLL_HUE_BRIDGE_STATUS';
export const SEARCH_FOR_BRIDGE = 'SEARCH_FOR_BRIDGE';

export const AGAIN = '_AGAIN';

export const hueBridgeStatuses = {
    AUTHENTICATED: 'AUTHENTICATED',
    AUTHENTICATION_REQUIRED: 'AUTHENTICATION_REQUIRED',
    NOT_AUTHENTICATED: 'NOT_AUTHENTICATED',
    NOT_AUTHENTICATED_AGAIN: 'NOT_AUTHENTICATED_AGAIN',
    NOT_FOUND: 'NOT_FOUND',
    RETRY: 'RETRY',
    SEARCHING: 'SEARCHING'
};

export const transientStatuses = [
    hueBridgeStatuses.RETRY,
    hueBridgeStatuses.SEARCHING,
    hueBridgeStatuses.AUTHENTICATION_REQUIRED
];



// WEBPACK FOOTER //
// ./src/core/state/install-hue-bridge/constants.js